export enum Channel {
  CHAT = 'chat',
  EMAIL = 'email',
  PUSH = 'push',
  SMS = 'sms',
  VOICE = 'voice'
}
